import { URLS } from '../../../consts/endpoints';
import checkIfIsEsimCard from '../../../utils/checkIfIsEsimCard';
import checkIfIsIoT from '../../../utils/checkIfIsIoT';
import { getData } from '../../../utils/http';
import Optional from '../../../utils/optional';

const getExtraSimcardDetails = async (clientId, icc) => {
  let activationCode = void 0;
  let isESimCard = false;
  let isIoTCard = false;

  try {
    const response = await getData(
      `${URLS.QUOTE_CLIENTS}/${clientId}/resources/search?icc=${[icc]}`
    );

    activationCode = Optional(response?.activationCode).or(void 0);
    isESimCard = checkIfIsEsimCard(response?.simCardType);
    isIoTCard = checkIfIsIoT(response?.usage_type);
  } catch {
    return void 0;
  }

  return { activationCode, isESimCard, isIoTCard };
};

export default getExtraSimcardDetails;
